export const SOMETHING_WRONG_MSG = "constants.errors.somethingWrong"
export const REQUEST_ABORTED_MSG = "You aborted the request." // no used
export const WARNING_MSG = "Warning" // no used

// need align backend error code
export const ErrorCode = {
  // no error
  NONE: 0,

  // system errors: 10000 to 10999
  SYS_PERMISSION_DENIED: 10001,
  SYS_VALIDATION_ERROR: 10002,
  SYS_NOT_FOUND: 10003,
  SYS_NOT_ALLOWED: 10004,
  SYS_SERVER_ERROR: 10005,
  SYS_BAD_REQUEST: 10006,

  // auth errors: 11000 to 11999
  AUTH_ALREADY_AUTHENTICATED: 11001,
  AUTH_INVALID_CREDENTIALS: 11002,
  AUTH_USER_DISABLED: 11003,
  AUTH_EMAIL_NOT_VERIFIED: 11005,
  AUTH_PASSWORD_REUSED: 11006,
  AUTH_EMAIL_ALREADY_REGISTERED: 11007,

  // production errors: 12000 to 12999
  PROD_AI_ERROR: 12001,
  PROD_CONTEXT_QUERY_ERROR: 12002,

  // prompt ERROR: 13000 to 13999
  PROMPT_NOT_FOUND: 13001,

  // organization workspace errors: 14000 to 14999
  WORKSPACE_NOT_FOUND: 14001,
  WORKSPACE_CANNOT_DELETE_DEFAULT: 14002,
  WORKSPACE_PERMISSION_DENIED: 14003,
  WORKSPACE_CREATION_FAILED: 14004,
  WORKSPACE_LIMIT_EXCEEDED: 14005,
  DISTRIBUTION_LIMIT_PER_ORG_EXCEEDED: 14006,
  END_USER_LIMIT_EXCEEDED: 14007,
  ORGANIZATION_NOT_FOUND: 14100,
  WORKSPACE_USER_NOT_FOUND: 14101,
  ORGANIZATION_USER_NOT_FOUND: 14102,
  ORG_BUDGET_INSUFFICIENT: 14110,
  ORG_BUDGET_LOCKED: 14111,
  END_USER_CREDIT_CAP_REACHED: 14116,
  PUBLISHED_CHANNEL_PUBLISH_IN_PROGRESS: 14117,
  INVITATION_INVALID: 14200,
  INVITATION_EXPIRED: 14201,
  INVITATION_NO_LONGER_VALID: 14202,
  INVITATION_EMAIL_MISMATCH: 14203,

  // agent errors: 15000 to 15999
  AGENT_NOT_FOUND: 15001,
  AGENT_INVALID_CONTEXT_SOURCE: 15002,

  // context source errors: 16000 to 16999
  CONTEXT_SOURCE_NOT_FOUND: 16001,
  CONTEXT_SOURCE_CREDENTIAL_EXPIRED: 16002,
  KNOWLEDGE_BASE_STORAGE_LIMIT_EXCEEDED: 16003,
}

export function isOrgBudgetErrorCode(errorCode?: number | null): boolean {
  return (
    errorCode === ErrorCode.ORG_BUDGET_INSUFFICIENT ||
    errorCode === ErrorCode.ORG_BUDGET_LOCKED
  )
}

export function isEndUserCreditCapErrorCode(
  errorCode?: number | null
): boolean {
  return errorCode === ErrorCode.END_USER_CREDIT_CAP_REACHED
}

export function getLimitErrorTranslationKey(errorCode?: number): string | null {
  switch (errorCode) {
    case ErrorCode.WORKSPACE_LIMIT_EXCEEDED:
      return "billing.limits.workspaceLimitExceeded"
    case ErrorCode.DISTRIBUTION_LIMIT_PER_ORG_EXCEEDED:
      return "billing.limits.distributionLimitExceeded"
    case ErrorCode.END_USER_LIMIT_EXCEEDED:
      return "billing.limits.endUserLimitExceeded"
    case ErrorCode.KNOWLEDGE_BASE_STORAGE_LIMIT_EXCEEDED:
      return "billing.limits.knowledgeBaseStorageLimitExceeded"
    default:
      return null
  }
}
